import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_HOME, UPDATE_HOME_STATUS, UPDATE_HOME_ORDER_STATUS, ADD_HOME, EDIT_HOME, DELETE_HOME } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { GetHomeSuccess, GetHomeFailure, UpdateHomeStatusSuccess, UpdateHomeStatusFailure, UpdateHomeOrderStatusSuccess, UpdateHomeOrderStatusFailure, AddHomeFailure, AddHomeSuccess, EditHomeSuccess, EditHomeFailure, DeleteHomeSuccess, DeleteHomeFailure } from "../Actions/HomeAction";
import { logout } from "../../utils";

function* homeRequest() {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/homes`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetHomeSuccess(res.data));
    } else yield put(GetHomeFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetHomeFailure(e));
  }
}

function* homeStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_home_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateHomeStatusSuccess(res.data));
    } else yield put(UpdateHomeStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateHomeStatusFailure(e));
  }
}

function* homeOrderStatusRequest(actions) {
  let data = [];
  actions.payload.map((arr) => {
    data.push(arr);
  });
  const body = {
    data,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_home_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateHomeOrderStatusSuccess(res.data));
    } else yield put(UpdateHomeOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateHomeOrderStatusFailure(e));
  }
}

function* addHomeRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    title: actions.payload.title,
    ios_icon: actions.payload.iosIcon,
    android_icon: actions.payload.androidIcon,
    user_type: actions.payload.user_type,
    type: actions.payload.type,
    information: actions.payload.information,
    // app_android_url: actions.payload.app_android_url,
    // app_ios_url: actions.payload.app_ios_url,
    icon: actions.payload.icon,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_home`, getFormData(body), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddHomeSuccess(res.data));
    } else yield put(AddHomeFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddHomeFailure(e));
  }
}

function* editHomeRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    title: actions.payload.title,
    // ios_icon: actions.payload.iosIcon,
    // android_icon: actions.payload.androidIcon,
    user_type: actions.payload.user_type,
    type: actions.payload.type,
    information: actions.payload.information,
    app_android_url: actions.payload.app_android_url,
    app_ios_url: actions.payload.app_ios_url,
    icon: actions.payload.icon,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_home?id=${actions.payload.id}`, getFormData(body), { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(EditHomeSuccess(res.data));
    } else yield put(EditHomeFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditHomeFailure(e));
  }
}

function* deleteHomeRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/home/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteHomeSuccess(res.data));
    } else yield put(DeleteHomeFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteHomeFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_HOME, homeRequest);
  yield takeLatest(UPDATE_HOME_STATUS, homeStatusRequest);
  yield takeLatest(UPDATE_HOME_ORDER_STATUS, homeOrderStatusRequest);
  yield takeLatest(ADD_HOME, addHomeRequest);
  yield takeLatest(EDIT_HOME, editHomeRequest);
  yield takeLatest(DELETE_HOME, deleteHomeRequest);
}

export default function* HomeSaga() {
  yield all([actionWatcher()]);
}
